<script lang="ts">
    import Toggle from 'svelte-toggle';

    export let expanded = false;
    export let id: string;
    export let text: string;
    export let onExpandClick: (() => void) | undefined = undefined;
    export let onToggle: ((id: string, value: boolean) => void) | undefined = undefined;
    export let disabledToggle = false;
    export let active = false;

    const handleToggle = (event: CustomEvent<boolean>) => {
        if (!onToggle) return;

        onToggle(id, event.detail);
    };
</script>

<div class="mt-4 flex items-center">
    <button class="flex flex-1 items-center" on:click={onExpandClick}>
        {#if onExpandClick}
            <div class="triangle" class:expanded />
        {/if}
        <span>{text}</span>
    </button>
    <div>
        {#if onToggle || disabledToggle}
            <Toggle
                disabled={disabledToggle}
                on:toggle={handleToggle}
                toggled={active}
                hideLabel={true}
                toggledColor="#19ab27"
            />
        {/if}
    </div>
</div>

<style lang="scss">
    $textColor: #4a4a4a;

    .triangle {
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 0 6px 6px;
        border-color: transparent transparent transparent $textColor;
        transform: rotate(0deg);
        transition: 0.2s all ease;
        margin-right: 16px;
        cursor: pointer;

        &.expanded {
            transform: rotate(90deg);
        }
    }
</style>
